import { optionField, stringField } from 'common/utils/form/fieldTypes';

const config = {
  title: stringField({ required: true }),
  menu_id: optionField(),
  pages: { url: stringField() },
  content: stringField(),
  attachments: optionField()
};

export default config;
